import {
  type Action,
  type ControlType,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

export enum GamePageSection {
  ART_GALLERY = "art-gallery",
  GAMEPLAY = "gameplay",
  RIGHT_PANEL = "right-panel",
  BENTO_BOXES = "bento-boxes",
  TRAILER = "trailer",
  TOP_BUTTONS = "top-buttons",
  VIDEO_INTRO = "video-intro",
  ONBOARDING_MODAL = "onboarding-modal",
}

type GamePageExtras = {
  /** @description Control name in lower kebab-case */
  control?: Lowercase<string>;
  controlType?: ControlType;
  controlLabel?: string;
  section?: GamePageSection;
};

export type GamePageEvent = { action: Action; extras: GamePageExtras };

export const useGamePageAnalytics = () =>
  useAnalyticsTracker<GamePageEvent>(TrackObject.GAME_PAGE);
